import React from 'react'
import List from '../crud/list'
import menuItems from './menuItems'

const columns = [
  { title: 'Type', prop: 'type' },
  { title: 'Institution', prop: 'institution_id', references: 'admin/institutions', referenceProp: 'name' },
  { title: 'text', prop: 'text', format: 'html' },
  { title: 'Created', prop: 'created_at', format: 'fromNow' },
  { title: 'Updated', prop: 'updated_at', format: 'fromNow' }
]

const filters = [
  {
    name: 'Filter by type',
    prop: 'filters.type',
    type: 'autocomplete',
    references: 'admin/institution-notes',
    referenceProp: 'type',
    enabled: true
  }
]

const InstitutionNotes = (props) => {
  const defaults = {
    order: [{ column: 'created_at', direction: 'desc' }],
    filters: {
      institution_id: props.params.institutionId
    }
  }

  return (
    <List
      title='Institution Notes'
      apiPath='admin/institution_notes'
      columns={columns}
      filters={filters}
      defaults={defaults}
      buildMenuItems={menuItems}
      locationPathname={props.location.pathname}
      locationSearch={props.location.search}
      withExport
    />
  )
}

export default InstitutionNotes
